import React from 'react';
import { FaCaretRight } from 'react-icons/fa';
import { moeda } from '../../components/funcoes';
import * as S from './styles';
import { Spacer } from '../../components/Spacer';

export function ItemPedido({ product }) {
  return (
    <div>
      <S.ProdutoDescricao>
        <div>
          {product.quantidade}x ({product.unidade}) - {product.descricao}
        </div>
        <div>{moeda(product.preco * product.quantidade)}</div>
      </S.ProdutoDescricao>
      {product?.tamanho && (
        <S.ItemSectionTitle>
          <FaCaretRight />
          {product.tipo === 'PIZZA' && 'Tamanho:'}
          {product.tipo === 'PORCAO' && 'Porção:'}
          {!['PIZZA', 'PORCAO'].includes(product.tipo) &&
            ` Tamanho: ${product.tamanho}`}{' '}
        </S.ItemSectionTitle>
      )}

      {product.sabores.length > 0 && (
        <>
          <S.ItemSectionTitle>
            <FaCaretRight /> Sabor{product.sabores.length > 1 && 'res'} Adiciona
            {product.sabores.length > 1 ? 'is' : 'l'}:
          </S.ItemSectionTitle>
          <S.SectionBody>
            {product.sabores?.map((sabor) =>
              sabor.check ? (
                <S.Description key={sabor.label}>- {sabor.label}</S.Description>
              ) : null,
            )}
          </S.SectionBody>
        </>
      )}

      {product.BordaDescricao && (
        <>
          <S.ItemSectionTitle>
            <FaCaretRight /> Borda:
            <S.Description style={{ paddingLeft: 6, alignSelf: 'flex-end' }}>
              {product.BordaDescricao} - {moeda(product.BordaPreco)}
            </S.Description>
          </S.ItemSectionTitle>
        </>
      )}

      {product.montagem?.map((mont) => {
        return (
          <>
            <S.ItemSectionTitle key={mont.DescricaoMontagem}>
              <FaCaretRight />
              {mont.DescricaoMontagem}:
            </S.ItemSectionTitle>
            <S.SectionBody>
              {mont.produtos?.map((prod) => {
                return (
                  <S.Description key={prod.label}>
                    - {prod.label} - {prod.quantidade}x :{' '}
                    {moeda(prod.precoMontagem)}
                  </S.Description>
                );
              })}
            </S.SectionBody>
          </>
        );
      })}

      <Spacer y={10} />

      {product.obs !== '' && (
        <S.ItemSectionTitle>
          <FaCaretRight />
          Observação: {product.obs}
        </S.ItemSectionTitle>
      )}

      {product.adicionais.length > 0 && (
        <>
          <S.ItemSectionTitle>
            <FaCaretRight /> Adicional:
          </S.ItemSectionTitle>
          <S.SectionBody>
            {product.adicionais?.map((add) =>
              add.check ? (
                <S.Description key={add.label}>
                  - {add.label}: {moeda(add.preco * product.quantidade)}
                </S.Description>
              ) : null,
            )}
          </S.SectionBody>
        </>
      )}
    </div>
  );
}
